<template>
	<div>
		<nav id="header" class="uk-navbar-container uk-margin-small-bottom" uk-navbar>
			<div class="uk-navbar-left">
				<span class="uk-navbar-item uk-logo">店舗検索</span>
				<template v-if="this.roles.is_call_center">
					<div class="uk-navbar-item uk-margin-large-left">
						<a class="uk-button uk-button-small uk-button-primary" @click="toShopAnotherSearch">店舗状況照会</a>
						<span class="uk-navbar-item uk-padding-remove uk-margin-small-left" style="font-size: 0.8em;">※空き枠の検索が可能</span>
					</div>
				</template>
			</div>
			<div class="uk-navbar-right">
				<template v-if="this.roles.is_main_office">
					<div class="navbar-item uk-margin-right">
						<button class="uk-button uk-button-default" @click="returnButton">戻る</button>
					</div>
				</template>
				<div class="navbar-item">
					<button class="uk-button uk-text-small uk-button-small uk-button-default" @click="clickLogoutButton">ログアウト</button>
				</div>
			</div>
		</nav>

		<div class="uk-container uk-container-expand">
			<div class="uk-form-horizontal">
				<div class="uk-margin">
					<label class="uk-form-label" for="keyword">あいまい検索</label>
					<div class="uk-form-controls">
						<input id="keyword" class="uk-input" type="text" name="keyword" placeholder="キーワードを入力してください" @input="search">
					</div>
				</div>
			</div>
		</div>
		<div class="uk-container uk-container-expand">
			<div id="result">
				<h4 class="uk-heading-divider">検索結果</h4>
				<div class="list" uk-gird>
					<template v-for="(shop,index) in shops">
						<router-link class="uk-button uk-button-default" style='text-transform:none;' :key="index" v-bind:to="createReservationListURL(shop)">{{ shop.name }}</router-link>
					</template>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

	import Shop from '@/api/Shop'
	import Role from '@/api/Role'
	import StaffAuth from '@/api/StaffAuth'
	import CallCenterAuth from '@/api/CallCenterAuth'
	import BranchOfficeAuth from '@/api/BranchOfficeAuth'
	import MainOfficeAuth from '@/api/MainOfficeAuth'
	import RoleService from '@/services/RoleService'

	export default {
		name: 'ShopSearchPage',
		comments: [],
		data () {
			return {
				shops: [],
				roles: []
			}
		},
		filters: {
			moment: function (date) {
				return moment(date).format('YYYY年MM月DD日 HH時mm分')
			}
		},
		methods: {
			toShopAnotherSearch () {
				this.$router.push('/shop_another_search')
				location.reload()
			},
			returnButton () {
				if (this.roles.is_main_office) {
					this.$router.push('/main_office')
					location.reload()
				}
				if (this.roles.is_branch_office) {
					this.$router.push('/branch_office/login')
					location.reload()
				}
				if (this.roles.is_call_center) {
					this.$router.push('/call_center/login')
					location.reload()
				}

				self.$router.push('/')
				location.reload()
			},
			clickLogoutButton () {
				let self = this

				Role.show().then(function (response) {
					let role_ = response.data.data

					let return_url = '/'

					if (role_.is_main_office) {
						return_url = '/main_office/login'
					}

					if (role_.is_branch_office) {
						return_url = '/branch_office/login'
					}

					if (role_.is_call_center) {
						return_url = '/call_center/login'
					}

					StaffAuth.logout().then(function (response) {
						// CallCenterAuth.logout().then(function (response) {
							// BranchOfficeAuth.logout().then(function (responase) {
								// MainOfficeAuth.logout().then(function (response) {
									self.$router.push(return_url)
									location.reload()
								// })
							// })
						// })
					})
				})
			},
			createReservationListURL (shop) {
				return '/reservation_list/' + shop.id
			},
			search () {
				let self = this

				let params = new URLSearchParams()
				params.append('keyword', $('#keyword').val())
				params.append('status', 0)

				Shop.search(params).then(function (response) {
					self.shops = response.data.data
				})
			}
		},
		created () {
		},
		beforeMount () {
			let self = this

			Role.show().then(function (response) { // 権限取得
				self.roles = response.data.data
				let data = response.data

				if (data.data.is_main_office != true && data.data.is_branch_office != true && data.data.is_call_center != true) { // 権限が無い場合
					self.$router.push('/')
				}
			})

			let params = new URLSearchParams()
			params.append('status', 0)

			Shop.search(params).then(function (response) {
				self.shops = response.data.data
			})
		},
		mounted () {

		}

	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/page/ShopSearchPage.vue